module.exports = __webpack_public_path__ + "static/img/change-panel.5a3b861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/change-panel.png
// module id = Xan6
// module chunks = 1